import React, {Component} from 'react'

class TableHead extends Component {

    _handleChangeChecked = (e) => {
        const checked = e.target.checked
        const {onCheckALl} = this.props

        if (typeof onCheckALl === 'function') {
            onCheckALl(checked)
        }
    }

    renderHeaderNonSelect = () => {
        const {selectAll} = this.props

        return (
            <tr className='SkuHeadTable'>
                <th className='SelectBox'>
                    <input type='checkbox' checked={selectAll} onChange={this._handleChangeChecked}/>
                </th>
                <th className='Type'>Loại</th>
                <th className='Name'>Tên</th>
                <th className='Procedure'>Quy trình</th>
                <th className='ProductionProcess'>Quy trình sản xuất</th>
                <th className='Procedure'>Ép mex</th>
                <th className='Procedure'>Partner sản xuất</th>
                <th className='Procedure'>Thời gian cam kết</th>
                <th className='Procedure'>Thời gian sản xuất nhanh</th>
                <th className='DateCreated'>Ngày tạo</th>
                <th className='Status'>Trạng thái</th>
                <th className='ExportBy'>Export by</th>
                <th className='Actions'>Hành động</th>
            </tr>
        )
    }

    render() {
        return (
            <thead className="TableHead">
            {this.renderHeaderNonSelect()}
            </thead>
        )
    }
}

export default TableHead
